import type { ReactNode } from 'react'
import { AnimatedValue } from '../ui/AnimatedValue'
import { LoadingState } from '../ui'
import type { WidgetData } from './useWidgetData'

/** Stato comune dei widget: caricamento, errore dentro il riquadro, poi il contenuto. */
export function WidgetBody<T>({ state, children }: { state: WidgetData<T>; children: (data: T) => ReactNode }) {
  if (state.loading && !state.data) {
    return <LoadingState />
  }
  if (state.error) return <div className="text-danger md-typescale-body-small">Non disponibile: {state.error}</div>
  if (!state.data) return null
  return <>{children(state.data)}</>
}

export const formatNum = (v: number | null): string => (v === null ? '—' : v.toLocaleString('it-IT'))

export function formatPct(v: number | null): string {
  if (v === null) return '—'
  return (v * 100).toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%'
}

export function Stat({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div>
      <div className="text-muted md-typescale-body-small" title={hint}>
        {label}
      </div>
      <div className="md-typescale-emphasized-title-medium md-num"><AnimatedValue value={value} /></div>
    </div>
  )
}
